interface IUtils {
  toSnakeCase: (string: string) => string;
}

export const utils: IUtils = {
  toSnakeCase: (string: string): string => {
    return string
      .replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map((word: string) => word.toLowerCase())
      .join("_");
  },
};
